import React, { useEffect, useState, useRef } from "react";

//Importar helpers.
import { getUserRol } from "../../helpers/storage";
import { Divider } from "@mui/material";
import { Password }  from '@mui/icons-material/';

const MenuUserProfile = ({ setOpenCreateNewPassword }) => {

    const [userRol, setUserRol] = useState("");

    useEffect(() => { setUserRol(getUserRol()) }, [localStorage.getItem('empresaData')]);
    
    return (
         < div className="container-menu-user-profile" >
            {/* <span className="container-assingment__text">{userRol}</span> */}

            <Divider sx={{ height: "10px" }}/>
            <div className="container-text__create-new-password">
                <span  onClick={() => setOpenCreateNewPassword(true)}><Password sx={{ marginRight: "15px" }}/>Cambiar Contraseña</span>
            </div>
        </div>
    )
};

export default MenuUserProfile;